import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { StrapiQuotationUpdateData } from '../../api/strapiCrm';
import { strapiUpdateQuotation } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useUpdateQuotationMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { documentId: string; data: StrapiQuotationUpdateData }) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiUpdateQuotation(jwt, input.documentId, input.data);
    },
    onSuccess: async (_, variables) => {
      await qc.invalidateQueries({ queryKey: queryKeys.quotationsListPrefix(jwt) });
      await qc.invalidateQueries({
        queryKey: queryKeys.quotationDetail(jwt, variables.documentId),
      });
      await qc.invalidateQueries({
        queryKey: queryKeys.quotationLogs(jwt, variables.documentId),
      });
    },
  });
}
